import { FETCH_FINAL_RECIEPT } from '../constants/actionTypes'

export default (finalRecieptDetails = {}, action) => {
    switch (action.type) {
        case FETCH_FINAL_RECIEPT:
            return action.payload;
        default:
            return finalRecieptDetails;
    }
}